import NiceModal from "@ebay/nice-modal-react";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputNumber from "components/inputs/signUp/InputNumber";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";

function CartPage() {
    const cartData = useSelector((state) => state.cart.products);
    const dispatch = useDispatch();
    const [cartList, setCartList] = useState();
    const quantityRef = useRef();
    const { userName } = useContext(AuthContext);
    const { id } = useParams();
    const navigate = useNavigate();


    useEffect(() => {

        setCartList(cartData);
    }, [])
    


    const onQuantityChange = (id, newQuantity) => {
        if (Number(newQuantity) > 0) {
            // 수량이 0보다 큰 경우, 수량 업데이트
            dispatch(CartReducer.actions.updateQuantity({ productId: id, quantity: Number(newQuantity) }));
        } else {
            // 수량이 0이하인 경우, 상품 제거
            dispatch(CartReducer.actions.removeProductFromCart({ id: id }));
        }
        // 현재 상태를 기반으로 cartList 업데이트
        // 수량이 0 이하인 항목은 제외하고 업데이트
        const updatedCartList = cartList.filter((item) =>
            item.id !== id || (item.id === id && Number(newQuantity) > 0)
        ).map((item) =>
            item.id === id ? { ...item, quantity: Number(newQuantity) } : item
        );
        setCartList(updatedCartList);
    };

    const onOrderClick = () => {
        if (cartData.length > 0) {
            navigate(`/ws/${id}/homepage/orderSummary/cart`);
        } else {
            toast.error(`먼저 상품을 담아주세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };
    return (
        <Container maxWidth={1200}>
            <VerticalFlex gap={20}>
                <FlexChild>
                    <Center width={"100%"} textAlign={"left"}>
                        <P color={"black"} weight={"bold"} size={"min(3.2vw, 30px)"}>장바구니</P>
                    </Center>
                </FlexChild>
                <FlexChild height={"1px"} backgroundColor={"black"} />
                <FlexChild>
                    <VerticalFlex>
                        {
                            cartList &&
                            cartList.map((data, index) => (
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <img src={data.productImg} width={"100px"} />
                                        </FlexChild>
                                        <FlexChild>
                                            <P>{data.productName}</P>
                                        </FlexChild>
                                        <FlexChild>
                                            <InputNumber ref={quantityRef} value={data.quantity} onChange={(newValue) => onQuantityChange(data.id, newValue)} />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            ))
                        }
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <CustomButton text={"구입하기"} onClick={onOrderClick} />
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
}

export default CartPage;